export default "__VITE_ASSET__1Esrq5Vb__"